import 'twin.macro';
import React from 'react';
import { Menu } from '@teetsh/app/src/components/Menu';
import { DuplicateIcon } from 'components/Icons/icons/Duplicate';
import { useDuplicateEvaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/evaluations/useDuplicateEvaluation';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { useCarnetsDeNotes } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/useCarnetsDeNotes';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { carnetUrls } from '@teetsh/app/src/containers/CarnetsDeNotes/urls';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  evaluationId: string;
  carnetDeNotesId: string;
  children?: React.ReactNode;
  minimal?: boolean;
  className?: string;
}

export function CopyEvalButton(props: Props) {
  const { evaluationId, carnetDeNotesId, minimal } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  const { t } = useTranslation(['carnet', 'common']);
  const { notifySuccess } = useNotification();
  const { data } = useCarnetsDeNotes();

  const duplicateEval = useDuplicateEvaluation(carnetDeNotesId);
  return (
    <Tooltip2
      className={props.className}
      label={t('carnet:evaluationForm.actions.copyEvaluation')}
      zIndex="10"
    >
      <Menu portal>
        <Menu.Button
          className="group"
          aria-label="Dupliquer l'évaluation"
          loading={!data}
          minimal={minimal}
          icon={DuplicateIcon as any}
          tw="py-0"
          iconSize="lg"
        >
          {props.children}
        </Menu.Button>

        <Menu.Items>
          <div tw="py-2 px-2 text-sm text-muted font-medium">
            {t('carnet:evaluationForm.actions.copyOn')}
          </div>
          {(data || []).map(cdn => (
            <Menu.Item
              key={cdn.id}
              tw="whitespace-nowrap"
              onClick={() =>
                duplicateEval({ evaluationId, destCarnetId: cdn.id }).then(
                  newEvalId => {
                    notifySuccess({
                      title: t(
                        'carnet:evaluationForm.messages.copyEvaluationSuccess',
                      ),
                      actions: (
                        <ButtonLink
                          rightIcon={ArrowRight}
                          tw="text-positive-moderate"
                          intent="success"
                          to={`/annee-scolaire/${schoolyear.id}/ecole/${
                            school.id
                          }/${carnetUrls.evaluationDetail(
                            cdn.id,
                            newEvalId.id,
                          )}`}
                        >
                          {t('carnet:evaluationForm.actions.goToEvaluation')}
                        </ButtonLink>
                      ),
                    });
                  },
                )
              }
              text={cdn.name}
            />
          ))}
        </Menu.Items>
      </Menu>
    </Tooltip2>
  );
}
